export enum EBOL_TOKEN_VALIDATION_STATUS {
  ASSIGNED = 'assigned',
  UNASSIGNED = 'unassigned',
  INVALID = 'invalid',
}